import { render, staticRenderFns } from "./InboxAlert.vue?vue&type=template&id=6786983e&scoped=true"
import script from "./InboxAlert.vue?vue&type=script&lang=js"
export * from "./InboxAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786983e",
  null
  
)

export default component.exports